import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import history from 'utils/history';
import request from 'utils/request';
import { Form, Grid, Message } from 'semantic-ui-react';
import { LayoutContainer, LayoutGrid } from 'utils/layouts';
import Cookies from 'universal-cookie';
import {
  ninpathCheckLoginSuccessful,
  showLoader,
  hideLoader,
} from 'containers/TopPage/actions';

const NinpathCheckLoginPage = ({
  ninpathCheckLogin,
  startLoading,
  finishLoading,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const cookies = new Cookies();
  const [errors, setErrors] = useState('');
  const attemptLogin = (userEmail, userPassword) => {
    startLoading({ value: true });
    const url = `${process.env.REACT_APP_API_URL}/api/v1/amh_auth/login`;
    const obj = { email: userEmail, password: userPassword };
    const promise = request(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Content-Type': 'application/json',
        charset: 'UTF-8',
      },
    });
    promise.then(response => {
      if (response.amh_user !== undefined) {
        // AMH ユーザでログイン
        cookies.set('user_token', response.auth_token, { path: '/' });
        cookies.set('user_name', response.amh_user.name, { path: '/' });
        cookies.set('amh_user_id', response.amh_user.id, { path: '/' });
        // order matters!!!
        ninpathCheckLogin();
        history.push('/ninpath-check/info');
      } else {
        setErrors(response.messages);
      }
      finishLoading({ value: true });
    });
  };
  return (
    <LayoutContainer>
      <LayoutGrid centered columns={1}>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Grid.Column
            mobile={12}
            tablet={8}
            computer={6}
            style={{ margin: 'auto', transform: 'translateY(-10%)' }}
          >
            <h3
              style={{
                paddingLeft: 14,
                paddingBottom: 14,
                fontWeight: 500,
              }}
            >
              ninpathチェック　ログイン
            </h3>
            <Form
              onSubmit={evt => {
                evt.preventDefault();
                attemptLogin(email, password);
              }}
            >
              <Form.Field>
                <label htmlFor="email">メールアドレス</label>
                <input
                  name="email"
                  type="email"
                  value={email}
                  placeholder="aaa@example.com"
                  onChange={evt => setEmail(evt.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label htmlFor="password">パスワード</label>
                <input
                  name="password"
                  type="password"
                  placeholder="パスワード"
                  value={password}
                  onChange={evt => setPassword(evt.target.value)}
                />
              </Form.Field>
              <Form.Button
                primary
                className="ninpath__form__container login__page__button__container"
                disabled={email === '' || password === ''}
              >
                ログイン
              </Form.Button>
              <p style={{ textAlign: 'right' }}>
                <Link to="/ninpath-check/registration">新規登録はこちら</Link>
              </p>
              <p style={{ textAlign: 'right' }}>
                <Link to="/ninpath-check/forgotPassword">
                  パスワードを忘れた方
                </Link>
              </p>
              <p style={{ textAlign: 'right' }}>
                <a
                  target="_blank"
                  href="https://forms.gle/jSctkbwfkShMz29z7"
                  rel="noopener noreferrer"
                >
                  お問い合わせ
                </a>
              </p>
              {errors && errors !== '' && (
                <Message negative>
                  <Message.Header>エラー</Message.Header>
                  <p>{errors}</p>
                </Message>
              )}
            </Form>
          </Grid.Column>
        </Grid.Row>
      </LayoutGrid>
    </LayoutContainer>
  );
};

const mapDispatchToProps = dispatch => ({
  ninpathCheckLogin: () => dispatch(ninpathCheckLoginSuccessful()),
  startLoading: payload => dispatch(showLoader(payload)),
  finishLoading: payload => dispatch(hideLoader(payload)),
});
export default connect(
  null,
  mapDispatchToProps,
)(React.memo(NinpathCheckLoginPage));

NinpathCheckLoginPage.propTypes = {
  ninpathCheckLogin: PropTypes.any.isRequired,
  startLoading: PropTypes.func.isRequired,
  finishLoading: PropTypes.func.isRequired,
};
